import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Avatar,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  Dashboard as DashboardIcon,
  School as SchoolIcon,
  Forum as ForumIcon,
  People as PeopleIcon,
  Analytics as AnalyticsIcon,
  Settings as SettingsIcon,
  AutoAwesome as AutoAwesomeIcon,
  UploadFile as UploadFileIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import { WorkshopAdminApi } from "../../../api/workshop-admin-api";
import { WorkshopApi } from "../../../api/workshop-api";
import DttTableData from "../../../components/DttTableData";
import {
  GridColDef,
  GridFilterModel,
  GridLogicOperator,
  GridRowSelectionModel,
  GridSortModel,
} from "@mui/x-data-grid";
import WorkshopCreation from "./WorkshopCreation";
import { Link } from "react-router-dom";
import { useAlert } from "@/contexts/AlertContext";

export default function WorkshopCategory() {
  const [categories, setCategories] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const alert = useAlert();

   // State cho dialog tạo mới
   const [openCreateDialog, setOpenCreateDialog] = useState(false);
   const [newCategoryName, setNewCategoryName] = useState("");
   const [createDialogLoading, setCreateDialogLoading] = useState(false);
   const [createDialogError, setCreateDialogError] = useState("");
 
   // State cho dialog chỉnh sửa
   const [openEditDialog, setOpenEditDialog] = useState(false);
   const [currentCategory, setCurrentCategory] = useState(null); // Category đang được chỉnh sửa
   const [editCategoryName, setEditCategoryName] = useState("");
   const [editDialogLoading, setEditDialogLoading] = useState(false);
   const [editDialogError, setEditDialogError] = useState("");
 
   // State cho dialog xóa
   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
   const [deleteDialogLoading, setDeleteDialogLoading] = useState(false);
   const [deleteDialogError, setDeleteDialogError] = useState("");

  const categoryColumns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      flex: 2,
    },
    {
        field: "actions",
        headerName: "Actions",
        flex: 1,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Box sx={{ display: "flex", gap: 1 }}>
            <IconButton
              color="primary"
              aria-label="edit"
              onClick={() => handleOpenEditDialog(params.row)}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              color="error"
              aria-label="delete"
              onClick={() => handleOpenDeleteDialog(params.row)}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        ),
      },
  ];

  // Button options cho data grid
  const buttonOptions = [
    { label: "New Category" },
    { label: "Reload Data", icon: <RefreshIcon /> },
  ];

  // Fetch workshops data
  const fetchWorkshopCategory = async () => {
    setLoading(true);
    try {
      const response = await WorkshopApi.getListCategory();
      if (response && response.data) {
        setCategories(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching category:", error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkshopCategory(); // Fetch workshops on component mount
  }, []);

  // Xử lý menu click cho table workshops (New Category, Reload Data)
  const handleTableMenuClick = (index: number) => {
    if (index === 0) {
      handleOpenCreateDialog(); // Mở dialog tạo mới khi click "New Category"
    } else if (index === 1) {
      fetchWorkshopCategory(); // Tải lại dữ liệu khi click "Reload Data"
    }
  };

  // --- Chức năng CREATE ---
  const handleOpenCreateDialog = () => {
    setNewCategoryName(""); // Reset tên category
    setCreateDialogError(""); // Reset lỗi
    setOpenCreateDialog(true);
  };

  const handleCloseCreateDialog = () => {
    setOpenCreateDialog(false);
    setNewCategoryName("");
    setCreateDialogError("");
  };

  const handleCreateCategory = async () => {
    if (!newCategoryName.trim()) {
      setCreateDialogError("Category name cannot be empty.");
      return;
    }
    setCreateDialogLoading(true);
    setCreateDialogError("");
    try {
      // Sử dụng mockWorkshopApi.createCategory
      const res = await WorkshopAdminApi.createWorkshopCategory({
        name: newCategoryName
      });
      if(res.code == 200){
        fetchWorkshopCategory(); // Tải lại danh sách sau khi cập nhật thành công
        handleCloseCreateDialog();
      }else{
        alert.error(res.message)
      }
    } catch (error) {
      console.error("Error creating category:", error);
    //   setCreateDialogError("Không thể tạo category: " + error.message);
    } finally {
      setCreateDialogLoading(false);
    }
  };

  // --- Chức năng UPDATE ---
  const handleOpenEditDialog = (category: any) => {
    setCurrentCategory(category);
    setEditCategoryName(category.name); // Đặt tên hiện tại vào input
    setEditDialogError(""); // Reset lỗi
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setCurrentCategory(null);
    setEditCategoryName("");
    setEditDialogError("");
  };

  const handleUpdateCategory = async () => {
    if (!editCategoryName.trim()) {
      setEditDialogError("Category name cannot be empty.");
      return;
    }
    if (currentCategory && editCategoryName === currentCategory.name) {
      setEditDialogError("Category name remains unchanged.");
      return;
    }

    setEditDialogLoading(true);
    setEditDialogError("");
    try {
      // Sử dụng mockWorkshopApi.updateCategory
      const res = await WorkshopAdminApi.updateWorkshopCategory({
        id: currentCategory.id,
        name: editCategoryName
      });
      if(res.code == 200){
        fetchWorkshopCategory(); // Tải lại danh sách sau khi cập nhật thành công
        handleCloseEditDialog();
      }else{
        alert.error(res.message)
      }
      
    } catch (error) {
      console.error("Error updating category:", error);
    //   setEditDialogError("Không thể cập nhật category: " + error.message);
    } finally {
      setEditDialogLoading(false);
    }
  };

  // --- Chức năng DELETE ---
  const handleOpenDeleteDialog = (category: any) => {
    setCurrentCategory(category);
    setDeleteDialogError(""); // Reset lỗi
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setCurrentCategory(null);
    setDeleteDialogError("");
  };

  const handleDeleteCategory = async () => {
    if (!currentCategory) return;

    setDeleteDialogLoading(true);
    setDeleteDialogError("");
    try {
      // Sử dụng mockWorkshopApi.deleteCategory
      const res = await WorkshopAdminApi.deleteWorkshopCategory({
        id: currentCategory.id
      });
      if(res.code == 200){
        fetchWorkshopCategory(); // Tải lại danh sách sau khi cập nhật thành công
        handleCloseDeleteDialog();
      }else{
        alert.error(res.message)
      }
    } catch (error) {
      console.error("Error deleting category:", error);
    //   setDeleteDialogError("Không thể xóa category: " + error.message);
    } finally {
      setDeleteDialogLoading(false);
    }
  };

  return (
    <>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 4 }}>
          Category Management
        </Typography>

        <DttTableData
          columns={categoryColumns}
          rows={categories}
          loading={loading}
          buttonOptions={buttonOptions}
          onMenuClick={handleTableMenuClick}
          checkboxSelection={false}
          disableRowSelectionOnClick={false}
        />
      </Box>
      {/* Dialog for Create Category */}
      <Dialog 
        open={openCreateDialog} 
        onClose={handleCloseCreateDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 1 }}>Create New Category</DialogTitle>
        <DialogContent sx={{ pt: 2, pb: 2 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Category Name"
            type="text"
            fullWidth
            variant="outlined"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
            error={!!createDialogError}
            helperText={createDialogError}
            sx={{ mt: 1 }}
            placeholder="Enter category name..."
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={handleCloseCreateDialog} disabled={createDialogLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleCreateCategory}
            disabled={createDialogLoading || !newCategoryName.trim()}
            variant="contained"
            color="primary"
          >
            {createDialogLoading ? <CircularProgress size={24} /> : "Create"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for Edit Category */}
      <Dialog 
        open={openEditDialog} 
        onClose={handleCloseEditDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 1 }}>Edit Category</DialogTitle>
        <DialogContent sx={{ pt: 2, pb: 2 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Category Name"
            type="text"
            fullWidth
            variant="outlined"
            value={editCategoryName}
            onChange={(e) => setEditCategoryName(e.target.value)}
            error={!!editDialogError}
            helperText={editDialogError}
            sx={{ mt: 1 }}
            placeholder="Enter category name..."
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={handleCloseEditDialog} disabled={editDialogLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleUpdateCategory}
            disabled={editDialogLoading || !editCategoryName.trim()}
            variant="contained"
            color="primary"
          >
            {editDialogLoading ? <CircularProgress size={24} /> : "Update"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for Delete Category */}
      <Dialog 
        open={openDeleteDialog} 
        onClose={handleCloseDeleteDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 1 }}>Confirm Delete</DialogTitle>
        <DialogContent sx={{ pt: 2, pb: 2 }}>
          <Typography>
            Are you sure you want to delete category "
            <Typography component="span" fontWeight="bold">
              {currentCategory?.name}
            </Typography>
            "? This action cannot be undone.
          </Typography>
          {deleteDialogError && (
            <Typography color="error" sx={{ mt: 2 }}>
              {deleteDialogError}
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={handleCloseDeleteDialog} disabled={deleteDialogLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleDeleteCategory}
            disabled={deleteDialogLoading}
            variant="contained"
            color="error"
          >
            {deleteDialogLoading ? <CircularProgress size={24} /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
